import React from "react";
import { colors, gradients, transition } from "../theme";

const EpDirectorActionsBar = ({
  selectedCount,
  totalCount,
  allSelected,
  onToggleSelectAll,
  onValidateAllSelected,
  isBulkSaving,
}) => {
  const hasSelection = selectedCount > 0;
  const active = hasSelection && !isBulkSaving;

  return (
    <div
      data-tour="actions-bar"
      className="d-flex justify-content-between align-items-center mb-3 px-3 py-2 rounded"
      style={{
        background: hasSelection
          ? "linear-gradient(135deg, #f0fdf4, #dcfce7)"
          : colors.bg.page,
        border: hasSelection
          ? `1px solid ${colors.success.border}`
          : `1px solid ${colors.border.default}`,
        transition,
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        <label
          className="d-flex align-items-center mb-0"
          style={{ cursor: "pointer", gap: 8 }}
        >
          <input
            type="checkbox"
            checked={allSelected}
            onChange={onToggleSelectAll}
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
              accentColor: colors.success.dark,
            }}
          />
          <span
            style={{
              fontSize: 13,
              color: colors.text.secondary,
              fontWeight: 500,
            }}
          >
            Tout sélectionner
          </span>
        </label>

        <div
          style={{ width: 1, height: 20, background: colors.border.default }}
        />

        <button
          className="btn btn-sm"
          onClick={onValidateAllSelected}
          disabled={!hasSelection || isBulkSaving}
          style={{
            background: active ? gradients.success : colors.border.default,
            color: active ? colors.text.white : colors.text.muted,
            border: "none",
            borderRadius: 8,
            padding: "7px 16px",
            fontSize: 13,
            fontWeight: 700,
            boxShadow: active ? "0 2px 6px rgba(34,197,94,0.25)" : "none",
            transition,
          }}
        >
          {isBulkSaving ? (
            <i
              className="fa fa-spinner fa-spin mr-2"
              style={{ fontSize: 11 }}
            />
          ) : (
            <i className="fa fa-check-double mr-2" style={{ fontSize: 11 }} />
          )}
          Accorder les sélectionnées
        </button>
      </div>

      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        {hasSelection && (
          <div className="d-flex align-items-center" style={{ gap: 6 }}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: 22,
                height: 22,
                borderRadius: "50%",
                background: gradients.success,
                color: colors.text.white,
                fontSize: 11,
                fontWeight: 700,
              }}
            >
              {selectedCount}
            </div>
            <span
              style={{
                fontSize: 13,
                color: colors.success.text,
                fontWeight: 600,
              }}
            >
              sélectionné{selectedCount > 1 ? "s" : ""}
            </span>
            <div style={{ width: 1, height: 16, background: "#bbf7d0" }} />
          </div>
        )}
        <span style={{ fontSize: 13, color: colors.text.muted }}>
          {totalCount} allocataire{totalCount > 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );
};

export default React.memo(EpDirectorActionsBar);
